import React, { useContext, useEffect, useState } from "react";
import AppContext from "../utils/app-context.js";
import { useNavigate } from "react-router-dom";
import { nanoid } from "nanoid";
import { Link, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, RadioGroup, FormControlLabel, Radio, Grid, IconButton } from '@mui/material'
import theme from '../styles/theme'
import AltRouteIcon from '@mui/icons-material/AltRoute';
import AuthBox from "./auth-box";
import LoginDialog from "./dialogs/login";
import toast from "react-hot-toast";
import Messages from "../constants/app.js";
import { formatDate } from '../utils/utility.js';
import { promptStyles } from "../constants/index.js";
import { db } from "../utils/firebase.js";
import { doc } from "firebase/firestore";

export default function ForkProject() {
  //includeSelectedOrLatest_watchable = true;  // not handled,  partially implemented and commented out
  //includeSelectedOrLatest_seleactable_proxy_and_veneer = false // idea: not handled, requires sending over takes
  const { state, dispatch } = useContext(AppContext);
  // const story = state.stories.activeStory //state.story //state.stories.activeStory
  // const takes = state.stories.activeTakeList
  // const shots = state.stories.activeShotList
  const navigate = useNavigate();
  const [forkOpen, setForkOpen] = useState(false)
  const [mediaOption, setMediaOption] = useState("Selected Media");
  const [loginOpen, setLoginOpen] = useState(false)
  const isLoggedIn = Object.keys(state.userData).length != 0 ? true : false
  const loc = window.location;

  const handleOpen = () => {
    isLoggedIn ? setForkOpen(true) : setLoginOpen(true)
  };

  const handleAuthOpen = () => {
    setForkOpen(true)
  }

  const handleClose = () => {
    setForkOpen(false)
    setLoginOpen(false)
  };

  const handleMediaChange = (event) => {
    setMediaOption(event.target.value);
  };

  useEffect(() => {
    if (state.app.forkingStory && loc.pathname.indexOf(state.app.forkingStory.newStory.portal_id) == -1) {
      navigate('/p/' + state.app.forkingStory.newStory.portal_id)
    }
  }, [state.app.forkingStory])
  function forkIt() {
    const userRef = (state.userData?.id ? doc(db, 'users', state.userData.id) : null) || (state.userData?.ref?.ref ? state.userData.ref.ref : state.userData?.ref);
    const story = state.stories.activeStory;
    let storyRef = state.stories.activeStoryRef || story?.ref;
    if (storyRef && storyRef.ref && storyRef.ref.path) {
      storyRef = storyRef.ref;
    }
    if (!storyRef && state.app.portal?.creator_id && state.app.portal?.story_id) {
      storyRef = doc(db, 'users', state.app.portal.creator_id, 'stories', state.app.portal.story_id);
    }
    const portalId = nanoid(12);
    const created = new Date();

    if (!userRef) {
      toast.error(Messages.error.projectForkFailed);
      setForkOpen(false);
      return;
    }

    if (!storyRef) {
      console.log("FORK RETURN NO STORY REF", { storyRef, story });
      toast.error(Messages.error.projectForkFailed);
      setForkOpen(false);
      return;
    }

    try {
      const newStory = {
        title: formatDate(created, 'title'),
        portal_id: portalId,
        created_at: created,
        parts: story.parts,
        description: story.description ? story.description : "",
        last_cut: (mediaOption == "All Media") ? story?.last_cut || null : null,
        last_export: (mediaOption == "All Media") ? story?.last_export || null : null,
        defaultModels: story?.defaultModels || {},
        storyStyle: story?.storyStyle ? { selected: story?.storyStyle.selected ?? null, custom: story?.storyStyle.custom ?? null } : null,
        is_vertical: story?.is_vertical || false
      };
      if ("audio" in story && story.audio) {
        newStory["audio"] = story.audio;
      }

      dispatch({ type: "FORK_STORY", payload: { "mediaOption": mediaOption, "userRef": userRef, "storyRef": storyRef, "newStory": newStory } });
      setForkOpen(false);
      toast.success(
        Messages.info.projectForking,
      );
    } catch (error) {
      toast.error(
        Messages.error.projectForkFailed,
      );
    }
  }

  const forkDialog = <Dialog
    open={forkOpen}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">Fork Project</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Do you want to fork this project to make a separate copy?
      </DialogContentText>

      <RadioGroup value={mediaOption} onChange={handleMediaChange} sx={{ my: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={'auto'}>
            <FormControlLabel value="No Media" control={<Radio />} label="No Media" />
          </Grid>
          <Grid item xs={12} md={'auto'}>
            <FormControlLabel value="All Media" control={<Radio />} label="All Media" />
          </Grid>
          <Grid item xs={12} md={'auto'}>
            <FormControlLabel value="Selected Media" control={<Radio />} label="Selected Media" />
          </Grid>
        </Grid>
      </RadioGroup>


    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} >
        Cancel
      </Button>
      <Button variant="contained" onClick={forkIt} autoFocus>
        Yes
      </Button>
    </DialogActions>
  </Dialog>

  return (
    <>
      <IconButton href="#" onClick={handleOpen} title="Fork Project" sx={{ display: "inline-flex", flex: "initial !important", justifyContent: "center", padding: 0, /*padding: "8px !important"*/ }}>
        <AltRouteIcon sx={{ color: theme.palette.primary.contrastText }} />
      </IconButton>
      {isLoggedIn ? forkDialog : <LoginDialog open={loginOpen} onClose={handleClose} authFunc={handleAuthOpen} redirect={loc.pathname} value="Log in to fork a copy of this project." title="Fork Project" />}
    </>
  );
} 